// extracted by mini-css-extract-plugin
export default {"errorCard":"ErrorPageView_errorCard__jIhFq","errorDesc":"ErrorPageView_errorDesc__VMBCW"};